// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandableImage_container__IW_yd","button":"ExpandableImage_button__zU9jI","img":"ExpandableImage_img__ovefJ"};